import BroadcastScheduleControl from '../../components/LiveTV/BroadcastScheduleControl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { channels } from '../../graphqlDic'
import { graphql, compose } from 'react-apollo'

export default compose(
    graphql(channels, {
        name: 'channels'
    })
)(withRouter(
    connect(
        null,
        null
    )(BroadcastScheduleControl)
));



// WEBPACK FOOTER //
// ./src/containers/LiveTV/BroadcastScheduleControl.js